import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormFeedback,
} from "reactstrap"
import ReactQuill from "react-quill-new"
import "react-quill-new/dist/quill.snow.css"
import { Link } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import LoaderComponent from "components/loader"
import Spinners from "components/Common/Spinner"
import * as Yup from "yup"
import { useFormik } from "formik"
import toast from "react-hot-toast"
import {
  useUpdateAboutUsMutation,
  useLazyGetAboutUsQuery,
} from "store/api/blogs/aboutUs"
import Breadcrumb from "components/Common/Breadcrumb"
import editIcon from "../../assets/images/icons/edit.svg"

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  // ["blockquote", "code-block"],
  ["link", "image"],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  // [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
]

const AboutUs = () => {
  const [getResult, { isFetching }] = useLazyGetAboutUsQuery()
  const [update, { isLoading }] = useUpdateAboutUsMutation()
  const [readOnly, setReadOnly] = useState(true)

  document.title = "About Prachay | Prachay"

  const getData = async () => {
    try {
      const { success, data } = await getResult({
        key: "ABOUT_PRACHAY",
      }).unwrap()
      if (success) {
        validation.setFieldValue("aboutUs", data.value)
      }
    } catch (error) {}
  }

  const editBlog = async (values) => {
    try {
      const { success, message } = await update({
        ...values,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "aboutUsSuccess" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  useEffect(() => {
    getData()
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { aboutUs: "" },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await editBlog(values)
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"About Prachay"} />
          <Row>
            <Col xl={12}>
              <Card>
                {isFetching ? (
                  <LoaderComponent />
                ) : (
                  <CardBody>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Row className="mb-2">
                        <Col sm={12}>
                          <div className="position-relative">
                            {readOnly && (
                              <div
                                style={{
                                  position: "absolute",
                                  zIndex: 1,
                                  inset: 0,
                                  background: "rgb(0 0 0 / 10%)",
                                }}
                              >
                                <Button
                                  type="button"
                                  onClick={() => setReadOnly(false)}
                                  style={{
                                    position: "absolute",
                                    zIndex: 2,
                                    bottom: "20px",
                                    right: "20px",
                                  }}
                                >
                                  <img className="cp" src={editIcon} alt="" />{" "}
                                  Edit
                                </Button>
                              </div>
                            )}
                            <ReactQuill
                              theme="snow"
                              value={validation.values.aboutUs}
                              onChange={(e) =>
                                validation.setFieldValue("aboutUs", e)
                              }
                              placeholder="Update About Prachay..."
                              modules={{
                                toolbar: toolbarOptions,
                              }}
                            />
                          </div>
                          {validation.touched.aboutUs &&
                          validation.errors.aboutUs ? (
                            <FormFeedback type="invalid">
                              {validation.errors.aboutUs}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>

                      <Row className="justify-content-end mt-4">
                        <Col sm={12}>
                          <div className="d-flex justify-content-end align-items-center gap-3">
                            <Button
                              type="submit"
                              className="btn btn-primary w-md"
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <Spinners />
                              ) : (
                                "Update About Prachay"
                              )}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AboutUs
